// extracted by mini-css-extract-plugin
export default {"text-wrapper":"mAZF70It--TextWrapper_text-wrapper__8VI-1","textWrapper":"mAZF70It--TextWrapper_text-wrapper__8VI-1","text":"mAZF70It--TextWrapper_text__-oZm0"};